var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DIV } from '../dom';
import { getAssetManifest } from '../utils';
import './AssetsLoader.less';
var AssetsLoader = /** @class */ (function () {
    function AssetsLoader() {
        var _this = this;
        this.assets = {};
        this.el = new DIV('AssetsLoader', [
            (this.progressBar = new DIV('AssetsLoader__progressBar', [
                (this.progressBarValue = new DIV('AssetsLoader__progressBarValue')),
            ])),
            (this.message = DEVELOPMENT ? new DIV({ className: 'AssetsLoader__message', onClick: function () {
                    // @ts-ignore
                    _this.message.html("<code style=\"color:#990000\">".concat(_this.message.err.message, " <pre>").concat(_this.message.err.stack, "</pre></code>"));
                } }) : new DIV('AssetsLoader__message')),
        ]);
        this.initPromise = getAssetManifest()
            .then(function (res) { return _this.init(Object.entries(res.files)); })
            .catch(function (error) {
            _this.message.text(navigator.language.toLowerCase() == 'ru-ru'
                ? 'Что-то пошло не так. Попробуйте перезагрузить страницу.'
                : 'Something went wrong. Try reloading the page.');
            if (DEVELOPMENT) {
                // @ts-ignore
                _this.message.err = error;
                console.error(error);
            }
            return Promise.reject(error);
        });
    }
    AssetsLoader.getInstance = function () {
        if (!AssetsLoader.instance)
            AssetsLoader.instance = new AssetsLoader();
        return AssetsLoader.instance;
    };
    AssetsLoader.getAsset = function (src) {
        return AssetsLoader.getInstance().getAsset(src);
    };
    AssetsLoader.prototype.getAsset = function (src) {
        if (!this.assets[src])
            throw new Error("no asset \"".concat(src, "\""));
        return this.assets[src];
    };
    AssetsLoader.prototype.init = function (files) {
        return __awaiter(this, void 0, void 0, function () {
            var i, _a, key, src, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        files = files.filter(function (_a) {
                            var _ = _a[0], src = _a[1];
                            return /\.(png|svg|ttf)$/.test(src) && src !== 'favicon.png';
                        });
                        i = 0;
                        _d.label = 1;
                    case 1:
                        if (!(i < files.length)) return [3 /*break*/, 4];
                        _a = files[i], key = _a[0], src = _a[1];
                        if (DEVELOPMENT && i == 5 && location.search.includes('AssetsLoaderError'))
                            src = src + '-error';
                        _b = this.assets;
                        _c = src;
                        return [4 /*yield*/, this.loadAsset(key, src, i)];
                    case 2:
                        _b[_c] = _d.sent();
                        this.updateProgress(files.length, i + 1);
                        _d.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AssetsLoader.prototype.updateProgress = function (total, count) {
        if (total > 0) {
            var progress = Math.floor((count / total) * 100);
            this.progressBar.attr('progress', "".concat(progress, "%"));
            this.progressBarValue.style.width = "".concat(progress, "%");
        }
    };
    AssetsLoader.prototype.loadAsset = function (key, src, i) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (/\.(ttf)$/.test(src)) {
                            var font_1 = new FontFaceWrapper(key.replace('.ttf', ''), "url(".concat(src, ")"));
                            font_1
                                .load()
                                .then(function () { return resolve(font_1); })
                                .catch(function (e) { return console.error(e); });
                        }
                        else {
                            var img_1 = new Image();
                            if (DEVELOPMENT && location.search.includes('pauseAssetsLoader') && i > 10)
                                return;
                            img_1.onload = function () { return resolve(img_1); };
                            img_1.onerror = function () { return reject(); };
                            img_1.src = src;
                        }
                    })];
            });
        });
    };
    return AssetsLoader;
}());
var FontFaceWrapper = /** @class */ (function () {
    function FontFaceWrapper(family, source) {
        var _this = this;
        this.loaded = false;
        this.font = typeof FontFace !== 'undefined' ? new FontFace(family, source) : new FakeFontFace(family, source);
        this.status = this.font.status;
        this.source = source;
        this.promise = this.font.load();
        this.promise.then(function () {
            _this.status = _this.font.status;
            _this.loaded = true;
        });
    }
    FontFaceWrapper.prototype.load = function () {
        return this.promise;
    };
    return FontFaceWrapper;
}());
export { FontFaceWrapper };
var FakeFontFace = /** @class */ (function () {
    function FakeFontFace(family, _source) {
        this.status = 'unloaded';
        this.family = family;
    }
    FakeFontFace.prototype.load = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.status = 'loaded';
            resolve(null);
        });
    };
    return FakeFontFace;
}());
export { AssetsLoader };
